import React from "react";
import { Button, ButtonGroup, Col, Dropdown } from "react-bootstrap";
import { useRouter } from "next/router";
import { useEffect } from "react";
export const blogCategoryMenu = [
  { title: "All Categories", value: "All Categories", path: "/blog" },
  { title: "NBA Basketball Analysis", value: "NBA Basketball Analysis", path: "/blog/nba-basketball-analysis" },
  { title: "WNBA Basketball Analysis", value: "WNBA Basketball Analysis", path: "/blog/wnba-basketball-analysis" },
  // { title: "Picks & Predictions", value: "Picks & Predictions", path: "/blog/ncaa-picks-and-predictions" },
  { title: "NCAA Basketball Analysis", value: "NCAA Basketball Analysis", path: "/blog/ncaa-basketball-analysis" },
  { title: "🤑 Pick of the Day", value: "Pick of the Day", path: "/blog/pick-of-the-day" },
  // { title: "March Madness", value: "March Madness", path: "/blog/marchmadness" },
];

const BlogCategories = ({ activeTab, setActiveTab, usePath = false }) => {
  const router = useRouter();
  const { asPath } = router;

  useEffect(() => {
    if (usePath) {
      for (const category of blogCategoryMenu) {
        if (category.value === activeTab) {
          if (asPath !== category.path) {
            router.push(category.path);
          }
          break;
        }
      }
    }
  }, [activeTab, usePath]);
  return (
    <Col md={12} sm={12} xs={12}>
      <Dropdown className="hide-desktop mb-2">
        <Dropdown.Toggle style={{ color: "black" }} id="dropdown-basic">
          {activeTab}
        </Dropdown.Toggle>
        <Dropdown.Menu style={{ backgroundColor: "black" }}>
          <ButtonGroup style={{ flexDirection: "column" }}>
            {blogCategoryMenu.map((category) => (
              <Button
                key={category.value}
                onClick={(e) => setActiveTab(e.target.value)}
                style={{ color: "white", margin: 0 }}
                value={category.value}
              >
                {category.title}
              </Button>
            ))}
          </ButtonGroup>
        </Dropdown.Menu>
      </Dropdown>
      <div className="list-tab pb-5">
        {blogCategoryMenu.map((category) => (
          <button
            key={category.value}
            onClick={() => setActiveTab(category.value)}
            className={`list-item is-link fw-6 ${activeTab === category.value ? "active" : ""}`}
          >
            {category.title}
          </button>
        ))}
      </div>
    </Col>
  );
};

export default BlogCategories;
